import { api } from './client';

/*  Specchio dei contratti del registro delle modifiche.

    Solo letture, e non è una svista: le voci le scrive l'intercettore dentro la
    transazione della modifica che annotano. Un registro che si può aggiungere,
    correggere o cancellare da un'interfaccia non è la prova di niente.  */

export interface CampoRegistroLetto {
  campo: string;
  prima: string | null;
  dopo: string | null;
}

export interface VoceRegistroLetta {
  id: string;
  tabella: string;
  chiaveRiga: string;
  operazione: 'Inserita' | 'Modificata' | 'Cancellata';
  autore: string;
  /** Il nome per esteso, se la persona è ancora in tabella: il registro conserva il codice. */
  nomeAutore: string | null;
  avvenuta: string;
  correlazione: string | null;
  campi: CampoRegistroLetto[];
}

export const registro = {
  /** Lo storico di una riga: `tabella` è il nome nel database, `chiave` l'identificativo. */
  perRiga: (tabella: string, chiave: string) =>
    api.get<VoceRegistroLetta[]>(
      `/registro/${encodeURIComponent(tabella)}/${encodeURIComponent(chiave)}`,
    ),

  /** Tutto quello che una singola richiesta ha cambiato: il codice esce come X-Correlazione. */
  perRichiesta: (correlazione: string) =>
    api.get<VoceRegistroLetta[]>(`/registro/richiesta/${encodeURIComponent(correlazione)}`),
};
